import _construct from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import _classCallCheck from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/seabrookstudios/projects/18holes/course-designer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
var t,
    n = (function (t, n) {
  t.exports = function () {
    var t = {},
        n = "Array Object String Date RegExp Function Boolean Number Null Undefined".split(" ");

    function e() {
      return Object.prototype.toString.call(this).slice(8, -1);
    }

    for (var r = n.length; r--;) {
      t["is" + n[r]] = function (t) {
        return function (n) {
          return e.call(n) === t;
        };
      }(n[r]);
    }

    return t;
  }();
}(t = {
  exports: {}
}, t.exports), t.exports),
    e = n.isObject,
    r = n.isNumber,
    i = n.isArray,
    o = n.isString;

function s(t, n) {
  return n + t * (1 & n) >> 1;
}

function u(t, n) {
  return (t % n + n) % n;
}

function c(t, n) {
  if (!/^(N|S)?(E|W)?$/i.test(t)) throw new Error("Invalid compass direction: ".concat(t, ". Choose from E, SE, S, SW, W, NW, N or NE."));
  if (n = n.toLowerCase(), t = t.toUpperCase(), "pointy" === n && ["N", "S"].includes(t)) throw new Error("Direction ".concat(t, " is ambiguous for pointy hexes. Did you mean ").concat(t, "E or ").concat(t, "W?"));
  if ("flat" === n && ["E", "W"].includes(t)) throw new Error("Direction ".concat(t, " is ambiguous for flat hexes. Did you mean N").concat(t, " or S").concat(t, "?"));
  return {
    pointy: {
      E: 0,
      SE: 1,
      SW: 2,
      W: 3,
      NW: 4,
      NE: 5
    },
    flat: {
      SE: 0,
      S: 1,
      SW: 2,
      NW: 3,
      N: 4,
      NE: 5
    }
  }[n][t];
}

function a(t, n) {
  return r(t) || r(n) ? r(t) ? r(n) || (n = t) : t = n : t = n = 0, {
    x: t,
    y: n
  };
}

var h = [{
  q: 1,
  r: 0
}, {
  q: 0,
  r: 1
}, {
  q: -1,
  r: 1
}, {
  q: -1,
  r: 0
}, {
  q: 0,
  r: -1
}, {
  q: 1,
  r: -1
}],
    l = [{
  q: 2,
  r: -1
}, {
  q: 1,
  r: 1
}, {
  q: -1,
  r: 2
}, {
  q: -2,
  r: 1
}, {
  q: -1,
  r: -1
}, {
  q: 1,
  r: -2
}],
    f = {
  x: 1e-6,
  y: 1e-6
};

function d(t) {
  return r(t) ? this[t] : this[this.indexOf(t)];
}

function x(t) {
  var n = t.isValidHex;
  return function (t, e) {
    if (!n(e)) return this;
    var i = r(t) ? t : this.indexOf(t);
    return i < 0 ? this.push(e) : this[i] = e, this;
  };
}

function y(t, n) {
  var e = t.distance(n),
      r = 1 / Math.max(e, 1);
  var i = [];

  for (var _o = 0; _o <= e; _o++) {
    var _e = t.nudge().lerp(n.nudge(), r * _o).round();

    i.push(this.get(_e));
  }

  return i;
}

function g(t) {
  var n = t.isValidHex;
  return function (t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
    if (!n(t)) throw new Error("Invalid center hex: ".concat(t, "."));
    if (!this.get(t)) throw new Error("Center hex with coordinates ".concat(t, " not present in grid."));
    var i = [];

    for (var _n = -e; _n <= e; _n++) {
      for (var _o2 = Math.max(-e, -_n - e); _o2 <= Math.min(e, -_n + e); _o2++) {
        var _e2 = this.get(t.cubeToCartesian({
          q: t.q + _n,
          r: t.r + _o2
        }));

        t.equals(_e2) && !r || i.push(_e2);
      }
    }

    return i.filter(Boolean);
  };
}

function b(t) {
  var n = t.isValidHex,
      e = t.signedModulo,
      r = t.compassToNumberDirection;
  return function (t) {
    var _this = this;

    var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "all",
        s = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    if (!n(t)) throw new Error("Invalid hex: ".concat(t, "."));
    var u = s ? l : h;
    return "all" === i && (i = [0, 1, 2, 3, 4, 5]), [].concat(i).map(function (n) {
      o(n) && (n = r(n, t.orientation)), (n < 0 || n > 5) && (n = e(n, 6));
      var _u$n = u[n],
          i = _u$n.q,
          s = _u$n.r;
      return _this.get(t.cubeToCartesian({
        q: t.q + i,
        r: t.r + s
      }));
    }).filter(Boolean);
  };
}

function p() {
  if (0 === this.length) return 0;

  var _ref = this[0].isPointy() ? _toConsumableArray(this).sort(function (t, n) {
    return n.s - t.s || t.q - n.q;
  }) : _toConsumableArray(this).sort(function (t, n) {
    return t.q - n.q;
  }),
      t = _ref[0],
      n = _ref.length,
      e = _ref[n - 1];

  return e.toPoint().x - t.toPoint().x + this[0].width();
}

function q() {
  if (0 === this.length) return 0;

  var _ref2 = this[0].isPointy() ? _toConsumableArray(this).sort(function (t, n) {
    return t.r - n.r;
  }) : _toConsumableArray(this).sort(function (t, n) {
    return n.s - t.s || t.r - n.r;
  }),
      t = _ref2[0],
      n = _ref2.length,
      e = _ref2[n - 1];

  return e.toPoint().y - t.toPoint().y + this[0].height();
}

function P(t) {
  var n = t.Hex;
  return function (t, e) {
    return n().fromPoint(t, e);
  };
}

function w(t) {
  var n = t.Grid,
      e = t.Hex;
  return function (t) {
    var r = t.width,
        i = t.height,
        o = t.start,
        _t$direction = t.direction,
        s = _t$direction === void 0 ? 1 : _t$direction,
        _t$onCreate = t.onCreate,
        u = _t$onCreate === void 0 ? function () {} : _t$onCreate;
    o = e(o);

    var _$3$5$s = _slicedToArray({
      1: ["q", "r", "s"],
      3: ["r", "s", "q"],
      5: ["s", "q", "r"]
    }[s], 3),
        c = _$3$5$s[0],
        a = _$3$5$s[1],
        h = _$3$5$s[2],
        l = new n();

    l.width = r, l.height = i, l.start = o, l.direction = s;

    for (var _t = 0; _t < r; _t++) {
      for (var _n2 = 0; _n2 < i; _n2++) {
        var _o$cubeToCartesian;

        var _r = e(o.cubeToCartesian((_o$cubeToCartesian = {}, _defineProperty(_o$cubeToCartesian, c, _t + o[c]), _defineProperty(_o$cubeToCartesian, a, _n2 + o[a]), _defineProperty(_o$cubeToCartesian, h, -_t - _n2 + o[h]), _o$cubeToCartesian)));

        u(_r, l), l.push(_r);
      }
    }

    return l;
  };
}

function m(t) {
  var n = t.Grid,
      e = t.Hex;
  return function (t) {
    var r = t.size,
        i = t.start,
        _t$direction2 = t.direction,
        o = _t$direction2 === void 0 ? 1 : _t$direction2,
        _t$onCreate2 = t.onCreate,
        s = _t$onCreate2 === void 0 ? function () {} : _t$onCreate2;
    i = e(i);
    var u = {
      1: {
        rStart: function rStart() {
          return 0;
        },
        rEnd: function rEnd(t) {
          return r - t;
        }
      },
      5: {
        rStart: function rStart(t) {
          return r - t;
        },
        rEnd: function rEnd() {
          return r + 1;
        }
      }
    },
        _u$o = u[o],
        c = _u$o.rStart,
        a = _u$o.rEnd,
        h = new n();
    h.size = r, h.start = i, h.direction = o;

    for (var _t2 = 0; _t2 < r; _t2++) {
      for (var _n3 = c(_t2); _n3 < a(_t2); _n3++) {
        var _r2 = e(i.cubeToCartesian({
          q: _t2 + i.q,
          r: _n3 + i.r,
          s: -_t2 - _n3 + i.s
        }));

        s(_r2, h), h.push(_r2);
      }
    }

    return h;
  };
}

function H(t) {
  var n = t.Grid,
      e = t.Hex;
  return function (t) {
    var r = t.radius,
        i = t.center,
        _t$onCreate3 = t.onCreate,
        o = _t$onCreate3 === void 0 ? function () {} : _t$onCreate3;
    i = e(i);
    var s = new n();
    s.radius = r, s.center = i;

    for (var _t3 = -r; _t3 <= r; _t3++) {
      var _n4 = Math.max(-r, -_t3 - r),
          _u = Math.min(r, -_t3 + r);

      for (var _r3 = _n4; _r3 <= _u; _r3++) {
        var _n5 = e(i.cubeToCartesian({
          q: _t3 + i.q,
          r: _r3 + i.r,
          s: -_t3 - _r3 + i.s
        }));

        o(_n5, s), s.push(_n5);
      }
    }

    return s;
  };
}

function O(t) {
  var n = t.Grid,
      e = t.Hex,
      r = t.compassToNumberDirection,
      i = t.signedModulo;
  return function (t) {
    var u = t.width,
        c = t.height,
        a = t.start,
        _t$direction3 = t.direction,
        h = _t$direction3 === void 0 ? e().isPointy() ? 0 : 1 : _t$direction3,
        _t$onCreate4 = t.onCreate,
        l = _t$onCreate4 === void 0 ? function () {} : _t$onCreate4;
    a = e(a), o(h) && (h = r(h, a.orientation)), (h < 0 || h > 5) && (h = i(h, 6));

    var _h = _slicedToArray([["q", "r", "s"], ["r", "q", "s"], ["r", "s", "q"], ["s", "r", "q"], ["s", "q", "r"], ["q", "s", "r"]][h], 3),
        f = _h[0],
        d = _h[1],
        x = _h[2],
        _ref3 = a.isPointy() ? [u, c] : [c, u],
        _ref4 = _slicedToArray(_ref3, 2),
        y = _ref4[0],
        g = _ref4[1],
        b = new n();

    b.width = u, b.height = c, b.start = a, b.direction = h;

    for (var _t4 = 0; _t4 < g; _t4++) {
      var _n6 = s(a.offset, _t4);

      for (var _r4 = -_n6; _r4 < y - _n6; _r4++) {
        var _a$cubeToCartesian;

        var _n7 = e(a.cubeToCartesian((_a$cubeToCartesian = {}, _defineProperty(_a$cubeToCartesian, f, _r4 + a[f]), _defineProperty(_a$cubeToCartesian, d, _t4 + a[d]), _defineProperty(_a$cubeToCartesian, x, -_r4 - _t4 + a[x]), _a$cubeToCartesian)));

        l(_n7, b), b.push(_n7);
      }
    }

    return b;
  };
}

function v(t) {
  var n = t.Point;
  return function (t, e) {
    var _n8;

    var r;
    return (_n8 = n(t, e), r = _n8.x, e = _n8.y, _n8), n(this.x + r, this.y + e);
  };
}

function M(t) {
  var n = t.Point;
  return function (t, e) {
    var _n9;

    var r;
    return (_n9 = n(t, e), r = _n9.x, e = _n9.y, _n9), n(this.x - r, this.y - e);
  };
}

function C(t) {
  var n = t.Point;
  return function (t, e) {
    var _n10;

    var r;
    return (_n10 = n(t, e), r = _n10.x, e = _n10.y, _n10), n(this.x * r, this.y * e);
  };
}

function E(t) {
  var n = t.Point;
  return function (t, e) {
    var _n11;

    var r;
    return (_n11 = n(t, e), r = _n11.x, e = _n11.y, _n11), n(this.x / r, this.y / e);
  };
}

function j(t) {
  var n = t.ensureXY;
  var o = {
    add: v({
      Point: s
    }),
    subtract: M({
      Point: s
    }),
    multiply: C({
      Point: s
    }),
    divide: E({
      Point: s
    })
  };

  function s(t, s) {
    var u;
    return u = r(t) ? n(t, s) : i(t) ? n.apply(void 0, _toConsumableArray(t)) : e(t) ? n(t.x, t.y) : n(0), Object.assign(Object.create(o), u);
  }

  return s;
}

var S = j({
  ensureXY: a
});

var N = /*#__PURE__*/function (_Array) {
  _inherits(N, _Array);

  function N() {
    _classCallCheck(this, N);

    return _possibleConstructorReturn(this, _getPrototypeOf(N).apply(this, arguments));
  }

  _createClass(N, [{
    key: "fill",
    value: function fill() {
      throw new TypeError("Grid.prototype.fill is not implemented");
    }
  }, {
    key: "includes",
    value: function includes(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return !!(this.indexOf(t, n) + 1);
    }
  }, {
    key: "indexOf",
    value: function indexOf(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      var e = this.length;
      var r = Number(n);

      for (t = S(t), r = Math.max(r >= 0 ? r : e + r, 0); r < e; r++) {
        if (this[r].equals(t)) return r;
      }

      return -1;
    }
  }, {
    key: "lastIndexOf",
    value: function lastIndexOf(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length - 1;
      var e = this.length;
      var r = Number(n);

      for (t = S(t), r = r >= 0 ? Math.min(r, e - 1) : e + r; r >= 0; r--) {
        if (this[r].equals(t)) return r;
      }

      return -1;
    }
  }, {
    key: "push",
    value: function push() {
      var _get2;

      for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) {
        n[e] = arguments[e];
      }

      return (_get2 = _get(_getPrototypeOf(N.prototype), "push", this)).call.apply(_get2, [this].concat(_toConsumableArray(n.filter(N.isValidHex))));
    }
  }, {
    key: "splice",
    value: function splice(t, n) {
      var _get3;

      if (null == n) return _get(_getPrototypeOf(N.prototype), "splice", this).call(this, t);

      for (var e = arguments.length, r = new Array(e > 2 ? e - 2 : 0), i = 2; i < e; i++) {
        r[i - 2] = arguments[i];
      }

      return (_get3 = _get(_getPrototypeOf(N.prototype), "splice", this)).call.apply(_get3, [this, t, n].concat(_toConsumableArray(r.filter(N.isValidHex))));
    }
  }, {
    key: "unshift",
    value: function unshift() {
      var _get4;

      for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) {
        n[e] = arguments[e];
      }

      return (_get4 = _get(_getPrototypeOf(N.prototype), "unshift", this)).call.apply(_get4, [this].concat(_toConsumableArray(n.filter(N.isValidHex))));
    }
  }], [{
    key: "isValidHex",
    value: function isValidHex(t) {
      return !0 === (t || {}).__isHoneycombHex;
    }
  }]);

  return N;
}(_wrapNativeSuper(Array));

function R(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
}

function T(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = null != arguments[n] ? arguments[n] : {},
        r = Object.keys(e);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(e).filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    }))), r.forEach(function (n) {
      R(t, n, e[n]);
    });
  }

  return t;
}

function z(t, n) {
  if (null == t) return {};

  var e,
      r,
      i = function (t, n) {
    if (null == t) return {};
    var e,
        r,
        i = {},
        o = Object.keys(t);

    for (r = 0; r < o.length; r++) {
      e = o[r], n.indexOf(e) >= 0 || (i[e] = t[e]);
    }

    return i;
  }(t, n);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);

    for (r = 0; r < o.length; r++) {
      e = o[r], n.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(t, e) && (i[e] = t[e]);
    }
  }

  return i;
}

function V(t) {
  var n = t.Hex;
  return function () {
    return Object.assign(this, n.apply(void 0, arguments));
  };
}

function W() {
  return {
    x: this.x,
    y: this.y
  };
}

function G() {
  return {
    q: this.q,
    r: this.r,
    s: this.s
  };
}

function D(t) {
  var n,
      e,
      r = t.q,
      i = t.r;
  return this.isPointy() ? (n = r + s(this.offset, i), e = i) : (n = r, e = i + s(this.offset, r)), {
    x: n,
    y: e
  };
}

function A() {
  return "pointy" === this.orientation.toLowerCase();
}

function I() {
  return "flat" === this.orientation.toLowerCase();
}

function X() {
  var t = this.size.xRadius;
  return this.isPointy() ? t * Math.sqrt(3) : 2 * t;
}

function Y() {
  var t = this.size.yRadius;
  return this.isPointy() ? 2 * t : t * Math.sqrt(3);
}

function B(t) {
  var n = t.Point;
  return function () {
    var t = this.width(),
        e = this.height(),
        _this$origin = this.origin,
        r = _this$origin.x,
        i = _this$origin.y;
    return this.isPointy() ? [n(t - r, .25 * e - i), n(t - r, .75 * e - i), n(.5 * t - r, e - i), n(0 - r, .75 * e - i), n(0 - r, .25 * e - i), n(.5 * t - r, 0 - i)] : [n(t - r, .5 * e - i), n(.75 * t - r, e - i), n(.25 * t - r, e - i), n(0 - r, .5 * e - i), n(.25 * t - r, 0 - i), n(.75 * t - r, 0 - i)];
  };
}

function _(t) {
  var n = t.Point;
  return function () {
    var _this$origin2 = this.origin,
        t = _this$origin2.x,
        e = _this$origin2.y;
    return n(this.width() / 2 - t, this.height() / 2 - e);
  };
}

function L(t) {
  var n = t.Point;
  return function () {
    var t = this.q,
        e = this.r,
        r = this.size,
        i = r.xRadius,
        o = r.yRadius;
    var s, u;
    return this.isPointy() ? (s = i * Math.sqrt(3) * (t + e / 2), u = 3 * o / 2 * e) : (s = 3 * i / 2 * t, u = o * Math.sqrt(3) * (e + t / 2)), n(s, u);
  };
}

function k(t) {
  var n = t.Point,
      e = t.Hex;
  return function (t, r) {
    var _n$subtract;

    var _this$size = this.size,
        i = _this$size.xRadius,
        o = _this$size.yRadius;
    var s, u, c;
    return (_n$subtract = n(t, r).subtract(this.center()), s = _n$subtract.x, r = _n$subtract.y, _n$subtract), this.isPointy() ? (u = Math.sqrt(3) * s / (3 * i) - r / (3 * o), c = 2 / 3 * (r / o)) : (u = 2 / 3 * (s / i), c = Math.sqrt(3) * r / (3 * o) - s / (3 * i)), e({
      q: u,
      r: c,
      s: -u - c
    }).round();
  };
}

function F(t) {
  var n = t.Hex,
      e = t.Point;
  return function (t) {
    var _e3 = e(t),
        r = _e3.x,
        i = _e3.y;

    return n(this.x + r, this.y + i, T({}, this));
  };
}

function U(t) {
  var n = t.Hex,
      e = t.Point;
  return function (t) {
    var _e4 = e(t),
        r = _e4.x,
        i = _e4.y;

    return n(this.x - r, this.y - i, T({}, this));
  };
}

function $(t) {
  var n = t.Point;
  return function (t) {
    if (null != t && (i(t) || r(t.x) && r(t.y))) {
      var _n12 = n(t),
          _e5 = _n12.x,
          _r5 = _n12.y;

      return this.x === _e5 && this.y === _r5;
    }

    return !1;
  };
}

function J(t) {
  return Math.max(Math.abs(this.q - t.q), Math.abs(this.r - t.r), Math.abs(this.s - t.s));
}

function K(t) {
  var n = t.Hex;
  return function () {
    var t = this.q,
        e = this.r,
        r = this.s,
        i = Math.round(t),
        o = Math.round(e),
        s = Math.round(r);
    var u = Math.abs(t - i),
        c = Math.abs(e - o),
        a = Math.abs(r - s);
    return u > c && u > a ? i = -o - s : c > a ? o = -i - s : s = -i - o, n(T({}, this, {
      q: i,
      r: o,
      s: s
    }));
  };
}

function Q(t) {
  var n = t.Hex;
  return function (t, e) {
    var r = this.q * (1 - e) + t.q * e,
        i = this.r * (1 - e) + t.r * e;
    return n(T({}, this, {
      q: r,
      r: i,
      s: -r - i
    }));
  };
}

function Z() {
  return this.add(f);
}

function tt() {
  return "".concat(this.x, ",").concat(this.y);
}

var nt = {
  thirdCoordinate: function thirdCoordinate(t, n) {
    return -t - n;
  }
};

var et = j({
  ensureXY: a
}),
    rt = function (t) {
  var n = t.ensureXY,
      o = t.normalizeRadiuses,
      u = t.Point;
  return function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

    var c = function (t) {
      var n = t.Point;
      return function (t, e) {
        var _n13;

        var r, i, o;
        return (_n13 = n(t, e), r = _n13.x, e = _n13.y, _n13), this.isPointy() ? (i = r - s(this.offset, e), o = e) : (i = r, o = e - s(this.offset, r)), {
          q: i,
          r: o,
          s: -i - o
        };
      };
    }({
      Point: u
    }),
        a = {
      __isHoneycombHex: !0,
      orientation: "pointy",
      origin: 0,
      size: {
        xRadius: 1,
        yRadius: 1
      },
      offset: -1,

      get q() {
        return this.cartesianToCube(this).q;
      },

      get r() {
        return this.cartesianToCube(this).r;
      },

      get s() {
        return this.cartesianToCube(this).s;
      },

      add: F({
        Hex: l,
        Point: u
      }),
      cartesian: W,
      cartesianToCube: c,
      center: _({
        Point: u
      }),
      coordinates: W,
      corners: B({
        Point: u
      }),
      cube: G,
      cubeToCartesian: D,
      distance: J,
      equals: $({
        Point: u
      }),
      fromPoint: k({
        Point: u,
        Hex: l
      }),
      height: Y,
      isFlat: I,
      isPointy: A,
      lerp: Q({
        Hex: l
      }),
      nudge: Z,
      round: K({
        Hex: l
      }),
      set: V({
        Hex: l
      }),
      subtract: U({
        Hex: l,
        Point: u
      }),
      toCartesian: D,
      toCube: c,
      toPoint: L({
        Point: u
      }),
      toString: tt,
      width: X
    },
        h = Object.assign(a, t);

    function l(t, o) {
      var _t5, _t6;

      var s,
          u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

      if (e(t)) {
        var _n14 = t.q,
            _e6 = t.r,
            _i = t.s,
            _c = z(t, ["q", "r", "s"]);

        if (r(_n14) || r(_e6) || r(_i)) {
          if (_n14 + _e6 + _i !== 0) throw new Error("Cube coordinates must have a sum of 0. q: ".concat(_n14, ", r: ").concat(_e6, ", s: ").concat(_i, ", sum: ").concat(_n14 + _e6 + _i, "."));

          var _h$cubeToCartesian = h.cubeToCartesian({
            q: _n14,
            r: _e6,
            s: _i
          });

          s = _h$cubeToCartesian.x;
          o = _h$cubeToCartesian.y;
        } else {
          s = t.x;
          o = t.y;
        }

        u = _c;
      } else i(t) ? ((_t5 = t, _t6 = _slicedToArray(_t5, 2), s = _t6[0], o = _t6[1], _t5), u = {}) : s = t;

      return Object.assign(Object.create(h), Object.assign(u, n(s, o)));
    }

    return h.size = o(h.size, h.isPointy()), h.origin = u(h.origin), Object.assign(l, nt), l;
  };
}({
  ensureXY: a,
  normalizeRadiuses: function normalizeRadiuses(t, n) {
    if (e(t)) {
      if (r(t.xRadius) && r(t.yRadius)) return t;
      var _e7 = t.width,
          _i2 = t.height;
      if (r(_e7) && r(_i2)) return n ? {
        xRadius: _e7 / Math.sqrt(3),
        yRadius: _i2 / 2
      } : {
        xRadius: _e7 / 2,
        yRadius: _i2 / Math.sqrt(3)
      };
    }

    if (r(t)) return {
      xRadius: t,
      yRadius: t
    };
    throw new Error("Invalid size: ".concat(t, ". Set it as a number or as an object containing width and height."));
  },
  Point: et
}),
    it = function (t) {
  var n = t.extendHex,
      e = t.Grid,
      r = t.Point;
  var o = e.isValidHex;
  return function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n();

    function s(t) {
      for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++) {
        r[s - 1] = arguments[s];
      }

      return i(t) ? r = t : r.unshift(t), _construct(e, _toConsumableArray(r.filter(o)));
    }

    return Object.assign(s, {
      Hex: t,
      isValidHex: o,
      pointToHex: P({
        Point: r,
        Hex: t
      }),
      parallelogram: w({
        Grid: e,
        Hex: t
      }),
      triangle: m({
        Grid: e,
        Hex: t
      }),
      hexagon: H({
        Grid: e,
        Hex: t
      }),
      rectangle: O({
        Grid: e,
        Hex: t,
        compassToNumberDirection: c,
        signedModulo: u
      })
    }), Object.assign(e.prototype, {
      get: d,
      hexesBetween: y,
      hexesInRange: g({
        isValidHex: o
      }),
      neighborsOf: b({
        isValidHex: o,
        signedModulo: u,
        compassToNumberDirection: c
      }),
      pointHeight: q,
      pointWidth: p,
      set: x({
        isValidHex: o
      })
    }), s;
  };
}({
  extendHex: rt,
  Grid: N,
  Point: et
});

export { et as Point, it as defineGrid, rt as extendHex };